export function emptyForNull(obj) {
    const result = {}
    for (const key of Object.keys(obj || {})) {
        result[key] = obj[key] == null ? '' : obj[key]
    }

    return result
}
